// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__24yQ4","notes":"Notes_notes__16nxM","note":"Notes_note__3E1Dz","markdown":"Notes_markdown__3Qanz"};